import { httpService } from "./http.service";

const BASE_URL = "group";

export const groupService = {
  getAll,
  getById,
  create,
  update,
  deleteGroup,
  duplicateGroup,
  moveTaskToAnotherGroup,
  getGroupsByBoardId,
  getBoardGroupsStatistics
};

async function getAll() {
  return await httpService.get(BASE_URL);
}

async function getById(id) {
  return await httpService.get(`${BASE_URL}/${id}`);
}

async function create(accountId, objGroup) {
  return await httpService.post(`${BASE_URL}/${accountId}`, objGroup);
}

async function update(accountId, id, objGroup) {
  return await httpService.put(`${BASE_URL}/${accountId}/${id}`, objGroup);
}

async function deleteGroup(accountId, id) {
  return await httpService.delete(`${BASE_URL}/${accountId}/${id}`);
}

async function duplicateGroup(id) {
  return await httpService.post(`${BASE_URL}/${id}/duplicate`);
}

async function getGroupsByBoardId(id) {
  return await httpService.get(`${BASE_URL}/by-board/${id}`);
}

async function getBoardGroupsStatistics(boardId, groupIds, cmpIds, filter = {}) {
  return await httpService.post(`${BASE_URL}/board/${boardId}/statistics`, {
    groupIds,
    cmpIds,
    searchTitle: filter.searchTitle || "",
    memberId: filter.memberId || "",
    status: filter.status || null,
    dynamic: filter.dynamic || {},
  });
}

async function moveTaskToAnotherGroup(accountId, taskId, fromGroupId, toGroupId, newIndex, byMember) {
  return await httpService.put(`${BASE_URL}/move-task/${accountId}/${taskId}`, {
    fromGroupId,
    toGroupId,
    newIndex,
    byMember
  });
}